import {
  ArrowRight,
  Clock,
  Rocket,
  ShoppingCart,
  Video,
  X,
} from "lucide-react";
import { ModalOption } from "./SelectModal";

const ComingSoonView: React.FC<{
  selectedOption: ModalOption;
  onBack: () => void;
  onClose: () => void;
}> = ({ selectedOption, onBack, onClose }) => {
  const isMarketplace = selectedOption === "marketplace";

  return (
    <div className="p-4 text-center">
      {/* Header */}
      <div className="flex items-center justify-between mb-8">
        <button
          onClick={onBack}
          className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          aria-label="Back to options"
        >
          <ArrowRight className="w-5 h-5 text-gray-500 rotate-180" />
        </button>
        <button
          onClick={onClose}
          className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          aria-label="Close modal"
        >
          <X className="w-5 h-5 text-gray-500" />
        </button>
      </div>

      {/* Coming Soon Badge */}
      <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-orange-100 to-red-100 rounded-full text-orange-700 font-medium mb-6">
        <Clock className="w-4 h-4" />
        Coming Soon
      </div>

      {/* Icon */}
      <div className="mb-6">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl shadow-xl">
          {isMarketplace ? (
            <ShoppingCart className="w-10 h-10 text-white" />
          ) : (
            <Video className="w-10 h-10 text-white" />
          )}
        </div>
      </div>

      {/* Title */}
      <h2 className="text-3xl font-bold text-gray-900 mb-4">
        {isMarketplace ? "Marketplace Integration" : "AI Video Generation"}
      </h2>

      {/* Description */}
      <p className="text-gray-600 mb-8 leading-relaxed max-w-md mx-auto">
        {isMarketplace
          ? "We're building an amazing feature that will let you create marketplace orders directly from your generated scripts with just one click."
          : "We're developing an intelligent AI system that will automatically generate high-quality videos from your scripts and content."}
      </p>

      {/* Feature Preview */}
      <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-6 mb-6">
        <div className="flex items-center justify-center gap-3 mb-4">
          <Rocket className="w-5 h-5 text-orange-600" />
          <h4 className="font-semibold text-gray-900">
            {isMarketplace ? "How it will work:" : "What's coming:"}
          </h4>
        </div>
        <ul className="text-left text-gray-700 space-y-3 text-sm max-w-sm mx-auto">
          {isMarketplace
            ? [
                "Select your generated script",
                "Choose marketplace preferences",
                "Create order with one click",
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></span>
                  {item}
                </li>
              ))
            : [
                "AI analyzes your script content",
                "Generates visuals and animations",
                "Produces professional video output",
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></span>
                  {item}
                </li>
              ))}
        </ul>
      </div>

      {/* Action Button */}
      <button
        onClick={onBack}
        className="w-full py-3 bg-gradient-to-r from-orange-500 to-red-600 text-white rounded-xl font-medium hover:from-orange-600 hover:to-red-700 transition-all duration-200 shadow-lg hover:shadow-xl"
      >
        Back to Options
      </button>
    </div>
  );
};

export default ComingSoonView;
